import {PopupDropdown} from '@wandb/common/components/PopupDropdown';
import React, {useState} from 'react';

import {Button} from '../../Button';
import {IconDelete} from '../../Icon';
import {DeleteTriggerModal} from './DeleteTriggerModal';
import * as S from './TriggerActions.styles';

type TriggerActionProps = {
  triggerID: string;
  triggerName: string;
  refetchProjectTriggers: () => Promise<any>;
  refetchCollectionTriggers?: () => Promise<any>;
};

export const TriggerActions = ({
  triggerID,
  triggerName,
  refetchCollectionTriggers,
  refetchProjectTriggers,
}: TriggerActionProps) => {
  const [isDeleteTriggerModalOpen, setDeleteTriggerModalOpen] = useState(false);
  const menuOptions = [
    {
      key: 'delete-automation',
      text: 'Delete automation',
      icon: <IconDelete style={{marginRight: '4px'}} />,
      onClick: () => {
        setDeleteTriggerModalOpen(true);
      },
    },
  ];

  return (
    <S.Buttons>
      <div>
        <PopupDropdown
          position="bottom right"
          trigger={<Button icon="overflow-horizontal" variant="ghost" />}
          options={menuOptions}
          offset={`-72px, -8px`}
        />
        <DeleteTriggerModal
          open={isDeleteTriggerModalOpen}
          onClose={() => setDeleteTriggerModalOpen(false)}
          triggerID={triggerID}
          triggerName={triggerName}
          afterDelete={async () => {
            await refetchProjectTriggers();
            if (refetchCollectionTriggers) {
              await refetchCollectionTriggers();
            }
          }}
        />
      </div>
    </S.Buttons>
  );
};
